<template>
    <b-navbar fixed-top>
        <template slot="brand">
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                <h1 class="is-size-5 has-text-primary">SEQu-DOC</h1>
            </b-navbar-item>
        </template>
        <template slot="start">
            <b-navbar-item>
                <span class="is-size-7">Virtual Clinic | Powered by Mica Health</span>
            </b-navbar-item>
        </template>
        <template slot="end">
            <b-navbar-item @click="logout">
                <span v-if="logoutLoading">Please wait...</span>
                <span v-else>Logout</span>
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ path: '/account' }">
                My Account
            </b-navbar-item>
        </template>
    </b-navbar>
</template>

<script>
    import BNavbarItem from "buefy/src/components/navbar/NavbarItem";
    export default {
        name: "Nav",
        components: {BNavbarItem},
        data() {
            return {
                logoutLoading: false
            }
        },
        methods: {
            logout() {
                const vm = this;
                vm.logoutLoading = true;
                vm.axios.post(`${vm.$host}/companyAdmins/logout?access_token=${localStorage.token}`)
                    .then(function (res) {
                        localStorage.removeItem('token');
                        localStorage.removeItem('user');
                        vm.logoutLoading = false;
                        vm.$router.push({name: 'Login'})
                    })
                    .catch(function (err) {
                        alert(err)
                    })
            }
        }
    }
</script>

<style scoped>

</style>